<template>
  <li class="flex items-center justify-between list-item-border py-base m-0">
    <div class="flex flex-1 flex-wrap items-center justify-between gap-sm">
      <div class="flex">
        <slot name="name"></slot>
      </div>

      <div class="flex items-center">
        <slot name="extraContent"></slot>
      </div>
    </div>
    <button
        data-test="x-button"
        @click="removeItem"
        type="button"
        class="tw-x mx-base">
      <XMarkIcon class="w-lg h-lg" />
    </button>
  </li>
</template>

<script>
import { XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'ListItem',
  components: {
    XMarkIcon,
  },
  methods: {
    removeItem() {
      this.$emit('remove');
    },
  },
};
</script>

<style scoped>
.list-item-border {
  border-bottom: 1px solid #dde2e5;
}
.list-item-border:first-of-type {
  border-top: 1px solid #dde2e5;
}
/* TODO cant get tailwind v2 to work with border top and border bottom - remove after upgrading to v3 */
</style>
